import * as React from "react";

export const ErrorContext = React.createContext({
  errors: [],
  deleteError: (_cellAddress: string) => {},
  clearErrors: () => {},
  openErrorDialog: false,
  setOpenErrorDialog: (_val) => {},
});

export default function ErrorContextProvider({ children }) {
  const [errors, setErrors] = React.useState([]);
  const [openErrorDialog, setOpenErrorDialog] = React.useState(false);

  const addError = (error) => {
    setErrors((prevErrors) => [...prevErrors, error]);
  };

  const deleteError = (errorIdx) => {
    setErrors((prevErrors) => prevErrors.filter((_err, idx) => idx !== errorIdx));
  };

  const clearErrors = () => {
    setErrors([]);
  };

  const handleError = (event: Event) => {
    addError((event as CustomEvent).detail);
  };

  React.useEffect(() => {
    if (errors.length > 0) {
      Office.addin.showAsTaskpane();
      setOpenErrorDialog(true);
    }
  }, [errors]);

  React.useEffect(() => {
    window.addEventListener("error", handleError);

    return () => {
      window.removeEventListener("error", handleError);
    };
  }, []);

  const ctx = {
    errors,
    deleteError,
    clearErrors,
    openErrorDialog,
    setOpenErrorDialog,
  };

  return <ErrorContext.Provider value={ctx}>{children}</ErrorContext.Provider>;
}
